(() => {
  'use strict';

  const CHAT_HANDLE_KEY =
    'ante_chat_current_product_handle_v10';

  const PRODUCT_STORAGE_KEY =
    'ante_current_product_v10';


  function safeDecode(value) {

    if (!value) return '';

    let result = String(value);

    for (let i = 0; i < 2; i += 1) {

      try {

        const decoded =
          decodeURIComponent(
            result.replace(/\+/g, ' ')
          );

        if (decoded === result) break;

        result = decoded;

      } catch (_error) {

        break;

      }

    }

    return result;
  }


  function getProductHandleFromPath(pathname) {

    const match =
      String(pathname || '')
        .match(
          /\/products\/([^/?#]+)/
        );

    return match
      ? safeDecode(match[1])
      : '';
  }


  function getProductHandle() {

    return getProductHandleFromPath(
      window.location.pathname
    );
  }


  function getLocaleRoot() {

    const root =
      window.Shopify?.routes?.root;

    return (
      typeof root === 'string' &&
      root.endsWith('/')
    )
      ? root
      : '/';
  }


  function readSavedProduct() {

    try {

      return JSON.parse(
        localStorage.getItem(
          PRODUCT_STORAGE_KEY
        ) || 'null'
      );

    } catch (_error) {

      return null;

    }

  }


  function saveProduct(product) {

    if (!product) return;

    try {

      localStorage.setItem(
        PRODUCT_STORAGE_KEY,
        JSON.stringify(product)
      );

    } catch (_error) {}

  }


  /*
    ========================================
    問い合わせページの商品情報
    ========================================

    URLに product / url / handle が
    明示されている場合だけ商品を認識。

    通常の /pages/contact では
    前の商品情報を引き継がない。
  */

  function getProductContextFromContactPage() {

    const path =
      window.location.pathname;

    const isContactPage =
      path.includes(
        '/pages/contact'
      ) ||
      path.includes(
        '/pages/ante-concierge'
      );

    if (!isContactPage) {
      return null;
    }


    const params =
      new URLSearchParams(
        window.location.search
      );


    const productTitle =
      safeDecode(
        params.get('product') ||
        params.get('product_name') ||
        params.get('product_title') ||
        params.get('title') ||
        ''
      );


    const productUrl =
      safeDecode(
        params.get('url') ||
        params.get('product_url') ||
        ''
      );


    const explicitHandle =
      safeDecode(
        params.get('handle') ||
        params.get('product_handle') ||
        ''
      );


    const hasExplicitProduct =
      Boolean(
        productTitle ||
        productUrl ||
        explicitHandle
      );


    /*
      通常のお問い合わせ。

      商品情報を持っていないため
      前の商品データを削除。
    */

    if (!hasExplicitProduct) {

      try {

        localStorage.removeItem(
          PRODUCT_STORAGE_KEY
        );

      } catch (_error) {}

      return null;
    }


    /*
      商品URLからhandleを取得
    */

    const urlHandle = (() => {

      if (!productUrl) {
        return '';
      }

      try {

        const parsed =
          new URL(
            productUrl,
            window.location.origin
          );

        return getProductHandleFromPath(
          parsed.pathname
        );

      } catch (_error) {

        return getProductHandleFromPath(
          productUrl
        );

      }

    })();


    const saved =
      readSavedProduct();


    const context = {

      title:
        productTitle ||
        saved?.title ||
        '',

      url:
        productUrl ||
        saved?.url ||
        '',

      handle:
        explicitHandle ||
        urlHandle ||
        saved?.handle ||
        '',

      vendor:
        saved?.vendor ||
        '',

      product_type:
        saved?.product_type ||
        '',

      variant_title:
        saved?.variant_title ||
        '',

      sku:
        saved?.sku ||
        '',

      price:
        saved?.price ??
        '',

      available:
        saved?.available ??
        null,

      saved_at:
        Date.now()

    };


    saveProduct(context);

    return context;
  }


  /*
    ========================================
    現在の商品を取得
    ========================================
  */

  async function getCurrentProduct() {

    const handle =
      getProductHandle();


    /*
      商品ページの場合
    */

    if (handle) {

      const endpoint =
        getLocaleRoot() +
        'products/' +
        encodeURIComponent(handle) +
        '.js';


      const response =
        await fetch(
          endpoint,
          {
            method: 'GET',
            credentials:
              'same-origin',
            cache:
              'no-store',
            headers: {
              Accept:
                'application/json'
            }
          }
        );


      if (!response.ok) {

        throw new Error(
          `Unable to retrieve the current product (${response.status}).`
        );

      }


      const product =
        await response.json();


      const variantId =
        new URLSearchParams(
          window.location.search
        ).get('variant');


      const selectedVariant =
        product.variants?.find(
          (variant) =>
            String(variant.id) ===
            String(variantId)
        ) ||
        product.variants?.[0] ||
        null;


      const currentProduct = {

        title:
          product.title ||
          '',

        url:
          window.location.href
            .split('#')[0],

        handle,

        vendor:
          product.vendor ||
          '',

        product_type:
          product.type ||
          '',

        variant_title:
          selectedVariant?.title ||
          '',

        sku:
          selectedVariant?.sku ||
          '',

        price:
          selectedVariant?.price ??
          product.price ??
          '',

        available:
          selectedVariant?.available ??
          product.available ??
          null,

        saved_at:
          Date.now()

      };


      saveProduct(
        currentProduct
      );

      return currentProduct;
    }


    /*
      問い合わせページの場合

      URLに商品情報がある時だけ
      現在の商品として扱う。
    */

    const contactProduct =
      getProductContextFromContactPage();


    if (contactProduct) {

      return contactProduct;

    }


    /*
      通常問い合わせページでは
      保存済みの商品を返さない。
    */

    const path =
      window.location.pathname;

    const isContactPage =
      path.includes(
        '/pages/contact'
      ) ||
      path.includes(
        '/pages/ante-concierge'
      );


    if (!isContactPage) {

      const savedProduct =
        readSavedProduct();

      if (savedProduct?.handle) {

        return savedProduct;

      }

    }


    throw new Error(
      'Current Ante product could not be identified.'
    );

  }


  /*
    ========================================
    Chatbase初期化待ち
    ========================================
  */

  function waitForChatbaseInitialized(
    callback
  ) {

    let completed = false;

    function checkChatbase() {

      if (completed) {
        return;
      }

      let state = '';

      try {

        state =
          typeof window.chatbase ===
          'function'
            ? window.chatbase(
                'getState'
              )
            : '';

      } catch (_error) {

        state = '';

      }

      if (
        state ===
        'initialized'
      ) {

        completed = true;

        window.clearInterval(
          timer
        );

        callback();

      }

    }

    /*
      Chatbaseはチャットを開いた時点で
      遅延初期化される場合があるため、
      30秒で監視を終了しない。

      initializedになるまで待機し、
      初期化完了後に一度だけcallbackを実行する。
    */

    const timer =
      window.setInterval(
        checkChatbase,
        500
      );

    checkChatbase();

  }

  /*
    ========================================
    Chatbase送信用シリアルマスク
    ========================================
  */

  function maskSerialForChatbase(text) {

    if (!text) return '';

    return String(text).replace(
      /(シリアル\s*[：:]|Serial(?:\s*(?:No\.?|Number))?\s*[：:])\s*([A-Za-z0-9\-]+)/gi,
      function (_match, label, serial) {

        const value = String(serial);
        const length = value.length;

        let visibleLength;

        if (length >= 7) {
          visibleLength = length - 4;
        } else if (length >= 3) {
          visibleLength = length - 2;
        } else if (length === 2) {
          visibleLength = 1;
        } else {
          visibleLength = 0;
        }

        const masked =
          value.slice(0, visibleLength) +
          '●'.repeat(length - visibleLength);

        return label + masked;
      }
    );
  }


  /*
    ========================================
    AI用の商品取得ツール
    ========================================
  */

  function registerCurrentProductTool() {

    window.chatbase(
      'registerTools',
      {

        get_current_product:
          async () => {

            try {

              const product =
                await getCurrentProduct();


              return {

                status:
                  'success',

                data: {

                  product_title:
                    product.title,

                  product_url:
                    product.url,

                  product_handle:
                    product.handle,

                  vendor:
                    product.vendor,

                  product_type:
                    product.product_type,

                  variant_title:
                    product.variant_title,

                  sku:
                    product.sku,

              price:
  product.price,

available:
  product.available,

case_size:
  window.AnteCurrentProductData?.case_size || '',

product_description:
  maskSerialForChatbase(
    window.AnteCurrentProductData?.description_text || ''
  )
                }

              };

            } catch (error) {

              console.error(
                'Ante get_current_product error:',
                error
              );


              return {

                status:
                  'error',

                error:
                  error.message ||
                  'Current product could not be retrieved.'

              };

            }

          }

      }
    );


    console.info(
      'Ante: get_current_product registered.'
    );

  }


  /*
    ========================================
    商品変更時のみAI会話をリセット
    ========================================
  */

  async function saveProductAndResetIfChanged() {

    let currentProduct = null;


    try {

      currentProduct =
        await getCurrentProduct();

    } catch (error) {

      /*
        通常問い合わせページでは
        商品が存在しないため正常。
      */

      const path =
        window.location.pathname;

      const isContactPage =
        path.includes(
          '/pages/contact'
        ) ||
        path.includes(
          '/pages/ante-concierge'
        );

      if (!isContactPage) {

        console.error(
          'Ante product preload error:',
          error
        );

      }

    }


    const currentHandle =
      currentProduct?.handle ||
      '';


    /*
      商品指定のない問い合わせページ
    */

    if (!currentHandle) {

      sessionStorage.removeItem(
        CHAT_HANDLE_KEY
      );

      return;

    }


    const previousHandle =
      sessionStorage.getItem(
        CHAT_HANDLE_KEY
      ) || '';


    /*
      商品が変わった場合だけ
      AI会話をリセット
    */

    if (
      previousHandle &&
      previousHandle !==
        currentHandle
    ) {

      try {

        if (
          window.chatbase &&
          typeof window.chatbase
            .resetChat ===
            'function'
        ) {

          window.chatbase
            .resetChat();

        } else if (
          typeof window.chatbase ===
          'function'
        ) {

          window.chatbase(
            'resetChat'
          );

        }


        console.info(
          `Ante: chat reset (${previousHandle} -> ${currentHandle}).`
        );

      } catch (error) {

        console.error(
          'Ante: chat reset failed:',
          error
        );

      }

    }


    sessionStorage.setItem(
      CHAT_HANDLE_KEY,
      currentHandle
    );

  }


  /*
    ========================================
    問い合わせフォーム自動入力
    ========================================
  */

  function findField(
    selectors,
    labelKeywords
  ) {

    for (
      const selector
      of selectors
    ) {

      const field =
        document.querySelector(
          selector
        );

      if (field) {
        return field;
      }

    }


    const labels =
      Array.from(
        document.querySelectorAll(
          'label'
        )
      );


    for (
      const label
      of labels
    ) {

      const labelText =
        String(
          label.textContent ||
          ''
        )
          .replace(/\s+/g, '')
          .toLowerCase();


      if (
        !labelKeywords.some(
          (keyword) =>
            labelText.includes(
              keyword
            )
        )
      ) {

        continue;

      }


      const targetId =
        label.getAttribute(
          'for'
        );


      if (targetId) {

        const field =
          document.getElementById(
            targetId
          );

        if (field) {
          return field;
        }

      }


      const nestedField =
        label.querySelector(
          'input, textarea'
        );


      if (nestedField) {

        return nestedField;

      }

    }


    return null;
  }


  function setFieldValue(
    field,
    value
  ) {

    if (
      !field ||
      !value
    ) {

      return false;

    }


    field.value =
      value;


    field.dispatchEvent(
      new Event(
        'input',
        {
          bubbles:
            true
        }
      )
    );


    field.dispatchEvent(
      new Event(
        'change',
        {
          bubbles:
            true
        }
      )
    );


    return true;
  }


  function fillProductContactFields() {

    const path =
      window.location.pathname;


    if (
      !path.includes(
        '/pages/contact'
      ) &&
      !path.includes(
        '/pages/ante-concierge'
      )
    ) {

      return true;

    }


    /*
      URLに商品情報がある場合だけ
      フォームへ商品情報を入れる。
    */

    const product =
      getProductContextFromContactPage();


    if (
      !product?.title ||
      !product?.url
    ) {

      return true;

    }


    const productNameField =
      findField(
        [
          'input[name*="[product_name]" i]',
          'input[name*="product_name" i]',
          'input[id*="product_name" i]',
          'input[id*="product-name" i]'
        ],
        [
          'ご相談の商品名',
          '商品名',
          'productname'
        ]
      );


    const productUrlField =
      findField(
        [
          'input[name*="[product_url]" i]',
          'input[name*="product_url" i]',
          'input[id*="product_url" i]',
          'input[id*="product-url" i]'
        ],
        [
          '商品ページurl',
          '商品url',
          'productpageurl',
          'producturl'
        ]
      );


    setFieldValue(
      productNameField,
      product.title
    );


    setFieldValue(
      productUrlField,
      product.url
    );


    return true;
  }


  /*
    ========================================
    初期化
    ========================================
  */

  function initialize() {

    /*
      問い合わせページの商品情報を
      URLから確認。
    */

    getProductContextFromContactPage();


    waitForChatbaseInitialized(
      () => {

        registerCurrentProductTool();

        saveProductAndResetIfChanged();

      }
    );


    fillProductContactFields();

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      {
        once:
          true
      }
    );

  } else {

    initialize();

  }

})();